import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { DetalheLeilao } from "src/app/model/leilao.model";
import { ResultadoPaginado } from "src/app/model/resultado";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";

export class FiltroCotistas {
  texto?: string;
  pagina?: number = 1;
  limite?: number = 10;
}

@Injectable({
  providedIn: "root",
})
export class DetalheLeilaoService extends FgiBackEndService<DetalheLeilao> {
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return "front/leiloes";
  }

  getDetalheLeilao(idLeilao: number): Observable<DetalheLeilao[]> {
    return this.http
      .get(`${this.BASE_URL}/${idLeilao}`)
      .pipe(
        catchError((e) => this.handleError(e))
      ) as Observable<DetalheLeilao[]>;
  }

  getDetalhesLeiloesPorFiltro(params?: any): Observable<ResultadoPaginado<DetalheLeilao>> {
    return this.http
      .get(`${this.BASE_URL}`, { params: params })
      .pipe(catchError((e) => this.handleError(e))) as Observable<
      ResultadoPaginado<DetalheLeilao>
    >;
  }
}
